'use client'
import React, { useState } from 'react';

const TravelHospitalIndustries = ({ color, textcolor, active, activetext }) => {
  const [activeTab, setActiveTab] = useState('first');

  return (
    <section className={`${color} text-${textcolor} mt-20`}>
      <div className="container mt-5">
        <div className="text-center">
          <h2 className="sec-subtile-6">IT Solutions for the Travel and Hospitality Industry</h2>
        </div>
        <h3 className="text-center py-3">Comprehensive IT Solutions for the Travel and Hospitality Industry</h3>
        <p className="text-center py-3">
          Our IT solutions cater to the diverse needs of the travel and hospitality sector, from online
          booking platforms to hotel management systems, enhancing operational efficiency and customer satisfaction.
        </p>
        <div className="row mt-5">
          {/* Tab section */}
          <div className="col-md-3 col-sm-12 py-2">
            <div className="d-flex flex-column align-items-center  h-100">

              <div className="d-block d-sm-none overflow-x-auto whitespace-nowrap w-100">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Online Booking Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Hotel Management Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Travel Agency Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Mobile Travel Apps
                </button>
              </div>

              <div className="d-none d-sm-flex flex-column ">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Online Booking <br />Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Hotel Management Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  Travel Agency Systems
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Mobile Travel Apps
                </button>
              </div>
            </div>
          </div>


          {/* Icon section */}
          <div className="col-md-9 col-sm-12 ">
            <div className="-brand__list -showcase-mixitup mt-3">
              {/* First Tab: EMR Solutions */}
              {activeTab === 'first' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Online Booking and Reservation Systems</h3>
                        <p>
                          Our real-time booking systems streamline bookings, integrate secure payments, and reduce manual errors for travel agencies and hotels.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Real-Time Availability</h4>
                          <p>Enables instant availability updates for all bookings and reservations.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Payment Integration</h4>
                          <p>Supports multiple currencies for secure global transactions with easy processing.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Reservation Management</h4>
                          <p>Centralizes and tracks all booking data for seamless management.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Calendar Sync</h4>
                          <p>Syncs booking calendars to avoid overlaps and manual scheduling conflicts.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Customer Reviews</h4>
                          <p>Allows customers to leave feedback, enhancing trust and service quality.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Dynamic Pricing</h4>
                          <p>Automatically adjusts pricing based on demand, ensuring optimal revenue.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Second Tab: Telemedicine Solutions */}
              {activeTab === 'second' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Hotel Management Software (HMS)</h3>
                        <p>
                          Our hotel management solutions automate room bookings, housekeeping, and billing, ensuring seamless operations for the hospitality industry.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Room Booking</h4>
                          <p>Manages room reservations and allocations efficiently for seamless operations.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Housekeeping Schedule</h4>
                          <p>Automates housekeeping schedules for clean and prepared rooms on time.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Check-In/Check-Out</h4>
                          <p>Simplifies guest check-in and check-out processes for quick guest turnover.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Billing System</h4>
                          <p>Automates billing processes and invoicing for smooth financial transactions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Guest CRM</h4>
                          <p>Tracks guest preferences and history for a personalized experience during stays.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Loyalty Integration</h4>
                          <p>Supports loyalty programs, offering rewards for returning customers.</p>
                        </div>
                      </div>
                    </div>

                  </section>
                </>
              )}

              {/* Third Tab: HMS Solutions */}
              {activeTab === 'third' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Travel Agency Management Systems</h3>
                        <p>
                          We provide custom travel agency systems that improve client engagement, streamline travel bookings, and offer enhanced customer service.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Package Management</h4>
                          <p>Organizes travel packages, tours, and customized trip offerings.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">CRM Integration</h4>
                          <p>Manages client relationships and interactions for enhanced services.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Flight/Hotel Booking</h4>
                          <p>Integrates flight and hotel booking options for streamlined operations.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Itinerary Builder</h4>
                          <p>Simplifies the creation of detailed itineraries for customer convenience.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Payment Gateway</h4>
                          <p>Provides secure, multi-currency payments for hassle-free transactions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">API Integration</h4>
                          <p>Connects with external travel services for smooth booking and management.</p>
                        </div>
                      </div>
                    </div>

                  </section>
                </>
              )}

              {/* Fourth Tab: HIE Solutions */}
              {activeTab === 'four' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Travel Mobile App Development</h3>
                        <p>
                          Our travel mobile apps enhance user experiences with real-time updates, bookings, and travel assistance, all available at users' fingertips.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Booking Services</h4>
                          <p>Allows users to book flights, hotels, and cars through an intuitive interface.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Itinerary Management</h4>
                          <p>Helps travelers manage and track their complete travel itineraries easily.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">GPS Navigation</h4>
                          <p>Provides GPS navigation and location services for easy trip planning.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Travel Alerts</h4>
                          <p>Sends real-time notifications for flight updates and important travel changes.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Language Support</h4>
                          <p>Offers multi-language support to cater to a global audience effortlessly.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Push Notifications</h4>
                          <p>Keeps users informed with important travel updates and reminders.</p>
                        </div>
                      </div>
                    </div>

                  </section>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default TravelHospitalIndustries;
